import { NewsletterEmailsView } from "../Views";

export const NewsletterEmailsPage = (props: { location: any }) => {
	return <NewsletterEmailsView location={props.location} />;
};
